import { setState } from '../analytics-state';

export const ddoReady = () => {

  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('ddo.ready', function () {
    setState({ ddoReady: true });
  });

};
